import React from 'react'
import BusinessEntity from './Subcomponents/BusinessEntity'
import EntityCount from './Subcomponents/EntityCount'

const BusinessEntities = ({ connector, businessEntitiesSource, businessEntitiesTarget, entityCount }) => (
    <>
        <EntityCount connector={connector} entityCount={entityCount} />
        <div className="scrollingContainer">
            <div className="row entityListNew">
                <BusinessEntity
                    sourceEntity={businessEntitiesSource}
                    targetEntity={businessEntitiesTarget}
                    sourceShortName={connector.source.shortName}
                    targetShortName={connector.target.shortName}
                />
            </div>
        </div>
    </>
)

export default BusinessEntities
